module.exports = __webpack_public_path__ + "img/sira_yes.1919aa05.png";